import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from '../../Interfaces/User';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {QueryService} from '../../Services/query.service';
import {Subscription} from 'rxjs';
import {GateTransactionDetailsView} from '../../Interfaces/GateTransactionDetailsView';
import {GateError} from '../../Interfaces/GateError';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {ListData} from '../../Interfaces/ListData';
import {GateDamages} from '../../Interfaces/GateDamages';
import * as XLSX from 'xlsx';
import {GateTransactionsExcelView} from '../../Interfaces/GateTransactionsExcelView';
import {Report} from '../../Interfaces/Report';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import NumberFormatOptions = Intl.NumberFormatOptions;

@Component({
  selector: 'app-gate-activity',
  templateUrl: './gate-activity.component.html',
  styleUrls: ['./gate-activity.component.css']
})
export class GateActivityComponent implements OnInit {
  public savedList: string;
  public driverTruckerColName: string;
  public savedLists : {code:string, description:string}[] = [];
  public savedList2: string;
  public savedLists2 : {id: string, code:string, description:string}[] = [];
  myNewListName: string = "";
  private listData: ListData[];
  private listDataObj: ListData;
  public didntEnterShit: boolean = false;
  public badChars: boolean = false;
  public badChassis: boolean = false;
  txtFromArea: string;
  containerNum: string;
  txtArray2: string [] = [];
  public notANumber: boolean = false;
  public submitted: boolean = false;
  public oneIsInAlready: boolean = false;
  private  myUser: User;
  public showQuickView: boolean = false;
  public badSearch: boolean = false;
  public showDetailScreen: boolean = false;
  public showDamages: boolean = false;
  showAcc: boolean = false;
  showGateInfo: boolean = false;
  showInspectionInfo: boolean = false;
  showErrorsInfo: boolean = false;



  geData: MatTableDataSource<GateError>;
  gdData: MatTableDataSource<GateDamages>;
  public geColumns: string[];
  public gdColumns: string[];
  phoneApp: boolean = false;
  ipadApp: boolean = false;
  public insertNoConts: boolean = false;
  public noListName: boolean = false;
  public insertListExists: boolean = false;
  reportsArray: Report[];
  report: Report;

  private clientRequest: ClientRequest;
  private subscription: Subscription;
  private gateDetails: GateTransactionDetailsView [] = [];
  private gateDetail: GateTransactionDetailsView;
  quickViewData: MatTableDataSource<GateTransactionDetailsView>;
  private gateDetailExcelArray: GateTransactionsExcelView[] = [];
  private gateDetailExcel: GateTransactionsExcelView;
  search1: UntypedFormControl;
  sub: any;
  sub2: any;
  public qvColumns: string[];
  public qvColumns2: string[];
  private currentIndx: number;
  private  date1: Date;
  private  number1: number;
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric", hour: "2-digit",minute:"2-digit"};
  private options2: NumberFormatOptions = {maximumFractionDigits: 2};
  weight: string;
  columnName: string;
   actionName: string;
   yardArea: string;
  maherError: string;
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData!=undefined){
      this.quickViewData.sort = sort;
    }

  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData!=undefined){
      this.quickViewData.paginator = pag;
    }

  }

  dontShowSearch(){
    if (this.ipadApp){
      this.inSearch = true;
      this.actionName = "XX";
    }
  }

  returnToSearch2(){
    if (this.ipadApp){
      this.inSearch = false;
      this.actionName = null;
      this.showQuickView = false;
    }
  }





  wipeOutScreen(){
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.txtFromArea = null;
    if (window.innerWidth > 800){
      this.fillUpSavedLists();
    }
  }


  exportExcel() {
    this.gateDetailExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++){
      this.gateDetailExcel = {} as GateTransactionsExcelView ;
      this.gateDetailExcel.Visit = this.quickViewData.filteredData[xx].visit;
      this.gateDetailExcel.Gate = this.quickViewData.filteredData[xx].gate_description;
      this.gateDetailExcel.Transaction = this.quickViewData.filteredData[xx].transaction_type_description;
      this.gateDetailExcel.EquipmentBooking = this.quickViewData.filteredData[xx].variousCol;
      this.gateDetailExcel.TruckingCo = this.quickViewData.filteredData[xx].driverOrTruckerCol;
      this.gateDetailExcel.Entered = this.quickViewData.filteredData[xx].lane_in_date;
      this.gateDetailExcel.Exited = this.quickViewData.filteredData[xx].guardOrLaneOutCol;
      this.gateDetailExcel.Stage = this.quickViewData.filteredData[xx].stage_id;
      this.gateDetailExcel.Status = this.quickViewData.filteredData[xx].transaction_status;
      this.gateDetailExcelArray.push(this.gateDetailExcel);

    }



    const workSheet = XLSX.utils.json_to_sheet(this.gateDetailExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:10},
      {wch:10},
      {wch:15},
      {wch:15},
      {wch:40},
      {wch:22},
      {wch:22},
      {wch:20},
      {wch:30},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'GateInquiry');
    XLSX.writeFile(workBook, 'gateInquiry.xlsx');
  }


  generateReport(urlIn: string){
    window.open(urlIn, "_blank");
  }



  getReports(visitIn: string){


    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.reportsArray = [];
    this.report = {} as Report;


    this.report.reportName = "TIR_REPRINT";
    this.report.visit = visitIn;

    this.reportsArray.push(this.report);

    this.clientRequest.requestData = this.reportsArray;

    const lhsUserObs$ = this.queryService.getDirectReports(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (reps) => {
        this.reportsArray = reps;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.reportsArray!=null){
          this.generateReport(this.reportsArray[0].reportUrl);
        }

      });
  }


  constructor(fb: UntypedFormBuilder,  private router: Router,private service: SharedVarService, private myApp:AppComponent, private  queryService: QueryService, private  globalEventsManager: GlobalEventsManager) {
    this.qvColumns = ["visit","gate_description","transaction_type_description","variousCol","driverOrTruckerCol","lane_in_date","guardOrLaneOutCol","stage_id","next_stage_id","slot","strad_status","transaction_status"];
    this.qvColumns2 = ["visit","gate_description","transaction_type_description","driverOrTruckerCol","lane_in_date","guardOrLaneOutCol","stage_id","transaction_status"];
    this.geColumns = ["error_description","error_date_fmt"];
    this.gdColumns = ["damage_component","damage_type","damage_severity_calc"];
    this.actionName = null;
    this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }});






    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
    this.myUser.company_code ="O7600"
    //this.myUser.company_code ="EGN"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "802007"
     this.myUser.role= "AGENT"
   // this.myUser.role= "LINEOP"
   // this.myUser.role= "HAULIER"
    this.myUser.username="CSPCRAIG"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "1";




 */

    this.sub2 =  this.service.getActionName().subscribe((value) => {
      if (value!=" "){
        this.actionName= value;
        this.yardArea= this.service.getGate();
        this.getSearchItems();
        this.service.setActionName(" ");
      }});

  }


  getColumnsToLookAt(): string[] {
    if (this.savedList=="Visit"){
      return this.qvColumns;
    }else{
      return this.qvColumns;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.sub2.unsubscribe();
  }

  ngOnInit() {


    this.search1 = new UntypedFormControl();
    this.savedLists = [];
    this.savedLists.push({"code": "Visit", "description": "Visit"});
    this.savedLists.push({"code": "Booking", "description": "Booking"});
    this.savedLists.push({"code": "Container", "description": "Container"});
    this.savedLists.push({"code": "Chassis", "description": "Chassis"});
    this.savedList = this.savedLists[0].code;
    if (window.innerWidth > 750 && window.innerWidth <1025){
      this.ipadApp = true;
    }

    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }
    this.getListData();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }
  public wipeOutSearch(){
    this.txtFromArea = null;
    this.showQuickView = false;
    this.showDetailScreen = false;
  }

  getSearchItems(){
    if (this.oneIsInAlready){
      return;
    }

    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.maherError = null;

    this.badSearch = false;
    this.didntEnterShit = false;
    this.badChars = false;
    this.badChassis = false;
    this.notANumber = false;
    this.gateDetail = {} as GateTransactionDetailsView;
    if (this.actionName==null) {


      if (this.txtFromArea == undefined) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');

      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length == 0) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
        if (this.txtArray2[_i]==""){
          this.txtArray2.splice(_i,1);
          continue;
        }
        if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
          this.containerNum = this.txtArray2[_i].valueOf();
          this.badChars = true;
          this.oneIsInAlready = false;
          return;
        }
        if (this.savedList=="Chassis" && !this.checkChassisFormat(this.txtArray2[_i].valueOf())){
          this.containerNum = this.txtArray2[_i].valueOf();
          this.badChassis = true;
          this.oneIsInAlready = false;
          return;
        }
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        } else {
          if (this.savedList == "Visit") {
            if (isNaN(Number(this.txtArray2[_i].valueOf()))) {
              this.notANumber = true;
              this.oneIsInAlready = false;
              return;
            }
          }
        }
      }
      if (this.txtArray2.length == 0) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

      this.didntEnterShit = false;



      this.gateDetails = [];
      for (var items of this.txtArray2) {
        this.gateDetail = {} as GateTransactionDetailsView;
        if (this.savedList == "Visit") {
          this.gateDetail.visit = items.valueOf();
        } else if (this.savedList == "Booking") {
          this.gateDetail.booking = items.valueOf();
        } else if (this.savedList == "Container") {
          this.gateDetail.container = items.valueOf();
        } else if (this.savedList == "Chassis") {
          this.gateDetail.chassis = items.valueOf();
        }
        this.gateDetails.push(this.gateDetail);
      }
    }else{
      this.gateDetails = [];
      this.gateDetail = {} as GateTransactionDetailsView;
      this.gateDetail.gate_description = this.yardArea;
      this.gateDetails.push(this.gateDetail);
    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.gateDetails;


    this.clearAllInfo();
    var lhsUserObs$;

    if (this.actionName!=null){
      if (this.actionName.toUpperCase()=="RECEIVE EMPTY"){
        lhsUserObs$ = this.queryService.getAllRMs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="RECEIVE IMPORT"){
        lhsUserObs$ = this.queryService.getAllRIs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="RECEIVE EXPORT"){
        lhsUserObs$ = this.queryService.getAllREs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="DELIVER EMPTY"){
        lhsUserObs$ = this.queryService.getAllDMs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="DELIVER IMPORT"){
        lhsUserObs$ = this.queryService.getAllDIs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="DELIVER EXPORT"){
        lhsUserObs$ = this.queryService.getAllDEs(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="COMPLETED"){
        lhsUserObs$ = this.queryService.getAllCompleted(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="IN PROGRESS"){
        lhsUserObs$ = this.queryService.getAllInProgress(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="CANCELLED"){
        lhsUserObs$ = this.queryService.getAllCancelled(this.clientRequest);
      }else if (this.actionName.toUpperCase()=="TROUBLE"){
        lhsUserObs$ = this.queryService.getAllInTrouble(this.clientRequest);
      }
    }else if (this.savedList=="Visit"){
      lhsUserObs$ = this.queryService.byVisit(this.clientRequest);
    }else if (this.savedList=="Booking"){
      lhsUserObs$ = this.queryService.byBooking(this.clientRequest);
    }else if (this.savedList=="Container"){
      lhsUserObs$ = this.queryService.byContainer(this.clientRequest);
    }else if (this.savedList=="Chassis") {
      lhsUserObs$ = this.queryService.byChassis(this.clientRequest);
    }

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.gateDetails = lhsUser;
      },
      error => {
        if (error.status == "401") {

          this.globalEventsManager.showLogin.emit(true);
          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.maherError = null;
        this.submitted = false;
        this.oneIsInAlready = false;

        if (this.gateDetails.length>0) {
            if (this.gateDetails.length == 1 || window.innerWidth <= 750) {
              if (this.gateDetails[0].maherError!=null ) {
                      this.maherError = this.gateDetails[0].maherError;
              } else {
                if (window.innerWidth <= 750){
                    this.gateDetails.sort(function(a, b) {
                      return Number.parseInt(b.gate_id) - Number.parseInt(a.gate_id);
                    });
                }


                this.gateDetail = this.gateDetails[0];
                this.currentIndx = 0;
                this.formatDetailScreen();
                this.showQuickView = false;
                this.showDetailScreen = true;
              }
            } else {
              for (var item of this.gateDetails){
                if (this.savedList=="Visit"){
                  this.columnName = "Container";
                }else{
                  this.columnName = this.savedList;
                }

                if (this.savedList=="Booking"){
                  item.variousCol =  item.booking;
                }else if (this.savedList=="Container" || this.savedList=="Visit"){
                  item.variousCol =  item.container;
                }else if (this.savedList=="Chassis") {
                  item.variousCol =  item.chassis;
                }
                if (item.maherError != null ) {
                  item.transaction_status = item.maherError;
                }else{
                  if (this.myUser.role=="HAULIER"){
                    item.driverOrTruckerCol = item.driver_name;
                    this.driverTruckerColName = "Driver Name";
                  }else{
                    item.driverOrTruckerCol = item.trucking_company_description;
                    this.driverTruckerColName = "Trucking Company";
                  }
                  if (item.gate=="EMPTY_DEPOT"){
                    item.guardOrLaneOutCol = item.exited_yard;
                  }else{
                    item.guardOrLaneOutCol = item.guard_out_date;
                  }

                }


              }
              if (window.innerWidth > 750 && window.innerWidth <1025){
                this.actionName = "XX";
              }
              this.showQuickView = true;
              this.showDetailScreen = false;
              this.search1.reset();
              this.quickViewData = new MatTableDataSource<GateTransactionDetailsView>(this.gateDetails);
              this.quickViewData.sortingDataAccessor = (item, property) => {
                switch (property) {
                  case 'lane_in_date':
                    return new Date(item.lane_in_date);
                  case 'visit':
                    return new Number(item.visit);
                  case 'guard_out_date':
                    return new Date(item.guard_out_date);
                  default:
                    return item[property];
                }
              };
            }
        }else{
          this.badSearch = true;
        }


      });

    //  }
  }

  nextTransaction(){
    this.currentIndx++;
    if (this.currentIndx<this.gateDetails.length){
      for (var dd=this.currentIndx; dd<this.gateDetails.length; dd++){
        if (this.gateDetails[dd].maherError!=null) {
          this.currentIndx++;
        }else{
          break;
        }
      }
      this.gateDetail = null;
      this.gateDetail = {} as GateTransactionDetailsView;
      this.gateDetail = this.gateDetails[this.currentIndx];
      this.clearAllInfo();
      this.showAcc = false;
      this.formatDetailScreen();
    }else{
      this.currentIndx=this.gateDetails.length-1;
      var _i = this.gateDetails.length;
      while (_i--) {
        if (this.gateDetails[_i].maherError !=null) {
        } else {
          this.currentIndx = _i;
          break;
        }
      }
    }
  }

  previousTransaction(){
    this.currentIndx--;
    if (this.currentIndx>=0){
      for (var dd=this.currentIndx; dd<this.gateDetails.length; dd--){
        if (this.gateDetails[dd].maherError!=null ) {
          this.currentIndx--;
        }else{
          break;
        }
      }
      this.gateDetail = null;
      this.gateDetail = {} as GateTransactionDetailsView;
      this.gateDetail = this.gateDetails[this.currentIndx];
      this.clearAllInfo();
      this.showAcc = false;
      this.formatDetailScreen();
    }else{
      this.currentIndx=0;
    }


  }

  returnToSearch(){
    this.showQuickView = false;
    this.showDetailScreen = false;
  }


  returnToQuickView(){
    this.showQuickView = true;
    this.showDetailScreen = false;
  }


  showDetails(rowIn: GateTransactionDetailsView){
    if (rowIn.maherError!=null) {
      return;
    }
    this.currentIndx = this.gateDetails.findIndex(xx => xx.container == rowIn.container);
    this.showQuickView = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.gateDetail = null;
    this.gateDetail = {} as GateTransactionDetailsView;
    this.gateDetail = rowIn;
    this.formatDetailScreen();
  }

  openGateTimes(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showGateInfo = true;
    },400);
  }

  openGateErrors(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showErrorsInfo = true;
    },400);
  }

  openInspectionTimes(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showInspectionInfo = true;
    },400);
  }

  openGateDamages(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showDamages = true;
    },400);
  }

  clearAllInfo(){
    this.showGateInfo = false;
    this.showErrorsInfo = false;
    this.showInspectionInfo = false;
    this.showDamages = false;

  }

  getNiceDate(dateIn: string): string {
    this.date1 = null;
    this.date1 =  new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options);
  }



  getNiceWeight(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options2);
  }


  formatDetailScreen() {
    if (this.gateDetail.driver_name == null) {
      this.gateDetail.driver_name = " ";
    }
    if (this.gateDetail.trucking_company_description == null) {
      this.gateDetail.trucking_company_description = " ";
    }
    if (this.gateDetail.visit == null) {
      this.gateDetail.visit = " ";
    }
    if (this.gateDetail.container == null) {
      this.gateDetail.container = " ";
    }
    if (this.gateDetail.container_iso_description == null) {
      this.gateDetail.container_iso_description = " ";
    }
    if (this.gateDetail.chassis == null) {
      this.gateDetail.chassis = " ";
    }
    if (this.gateDetail.hazardous == "1") {
      this.gateDetail.hazardousFmt = "Yes";
    }else{
      this.gateDetail.hazardousFmt = "No";
    }
    if (this.gateDetail.auto == "1") {
      this.gateDetail.autoFmt = "Yes";
    }else{
      this.gateDetail.autoFmt = "No";
    }
    if (this.gateDetail.roadability == "1") {
      this.gateDetail.roadabilityFmt = "Yes";
    }else{
      this.gateDetail.roadabilityFmt = "No";
    }
    if (this.gateDetail.placards == "1") {
      this.gateDetail.placardsFmt = "Yes";
    }else{
      this.gateDetail.placardsFmt = "No";
    }

    if (this.gateDetail.reefer == "1") {
      this.gateDetail.reeferFmt = "Yes";
    }else{
      this.gateDetail.reeferFmt = "No";
    }

    if (this.gateDetail.transaction_type_description == null) {
      this.gateDetail.transaction_type_description = " ";
    }
    if (this.gateDetail.line_id_description == null) {
      this.gateDetail.line_id_description = " ";
    }
    if (this.gateDetail.ssl_operator_description == null) {
      this.gateDetail.ssl_operator_description = " ";
    }
    if (this.gateDetail.transaction_status == null) {
      this.gateDetail.transaction_status = " ";
    }
    if (this.gateDetail.container_lease_description == null) {
      this.gateDetail.container_lease_description = " ";
    }
    if (this.gateDetail.vessel_description == null) {
      this.gateDetail.vessel_description = " ";
    }
    if (this.gateDetail.port_of_loading_description == null) {
      this.gateDetail.port_of_loading_description = " ";
    }
    if (this.gateDetail.voyage == null) {
      this.gateDetail.voyage = " ";
    }
    if (this.gateDetail.cancel_by == null) {
      this.gateDetail.cancel_by = " ";
    }
    if (this.gateDetail.remarks == null) {
      this.gateDetail.remarks = " ";
    }
    if (this.gateDetail.booking == null) {
      this.gateDetail.booking = " ";
    }

    if (this.gateDetail.temp_required_f == null){
      this.gateDetail.temp_required_fmt = " ";
    }else{
      if (this.gateDetail.temp_required_f!=null){
        this.gateDetail.temp_required_fmt = this.gateDetail.temp_required_f+" F";
      }
      if (this.gateDetail.temp_required_c!=null){
        this.gateDetail.temp_required_fmt = this.gateDetail.temp_required_fmt + " / "+this.gateDetail.temp_required_c+" C";
      }
    }

    if (this.gateDetail.humidity_required == null) {
      this.gateDetail.humidity_requiredFmt = " ";
    }else{
      this.gateDetail.humidity_requiredFmt = this.gateDetail.humidity_required + " %";

    }
    if (this.gateDetail.reefer_fuel_level == null) {
      this.gateDetail.reefer_fuel_levelFmt = " ";
    }else {
      this.gateDetail.reefer_fuel_levelFmt = this.gateDetail.reefer_fuel_level + " %";
    }

    if (this.gateDetail.reefer_hours == null) {
      this.gateDetail.reefer_hours = " ";
    }else{
      this.gateDetail.reefer_hours = this.getNiceWeight(this.gateDetail.reefer_hours);
    }
    if (this.gateDetail.genset == null) {
      this.gateDetail.genset = " ";
    }
    if (this.gateDetail.genset_type_description == null) {
      this.gateDetail.genset_type_description = " ";
    }


    if (this.gateDetail.over_height == null) {
      this.gateDetail.over_heightFmt = " ";
    } else {
      this.gateDetail.over_heightFmt = this.gateDetail.over_height + "cm / ";
      if (this.gateDetail.over_height_in!=null){
        this.gateDetail.over_heightFmt = this.gateDetail.over_heightFmt + this.gateDetail.over_height_in + "in"
      }
    }

    if (this.gateDetail.over_length_front == null) {
      this.gateDetail.over_length_frontFmt = " ";
    }else{
      this.gateDetail.over_length_frontFmt = this.gateDetail.over_length_front + "cm / ";
      if (this.gateDetail.over_length_front_in!=null){
        this.gateDetail.over_length_frontFmt = this.gateDetail.over_length_frontFmt + this.gateDetail.over_length_front_in + "in"
      }
    }


    if (this.gateDetail.over_length_rear == null) {
      this.gateDetail.over_length_rearFmt = " ";
    }else{
      this.gateDetail.over_length_rearFmt = this.gateDetail.over_length_rear + "cm / ";
      if (this.gateDetail.over_length_rear_in!=null){
        this.gateDetail.over_length_rearFmt = this.gateDetail.over_length_rearFmt + this.gateDetail.over_length_rear_in + "in"
      }
    }


    if (this.gateDetail.over_width_left == null) {
      this.gateDetail.over_width_leftFmt = " ";
    }else{
      this.gateDetail.over_width_leftFmt = this.gateDetail.over_width_left + "cm / ";
      if (this.gateDetail.over_width_left_in!=null){
        this.gateDetail.over_width_leftFmt = this.gateDetail.over_width_leftFmt + this.gateDetail.over_width_left_in + "in"
      }
    }

    if (this.gateDetail.over_width_right == null) {
      this.gateDetail.over_width_rightFmt = " ";
    }else{
      this.gateDetail.over_width_rightFmt = this.gateDetail.over_width_right + "cm / ";
      if (this.gateDetail.over_width_right_in!=null){
        this.gateDetail.over_width_rightFmt = this.gateDetail.over_width_rightFmt + this.gateDetail.over_width_right_in + "in"
      }
    }

    if (this.gateDetail.booking_ssl_description == null) {
      this.gateDetail.booking_ssl_description = " ";
    }
    if (this.gateDetail.booking_iso_description == null) {
      this.gateDetail.booking_iso_description = " ";
    }


    if (this.gateDetail.gross_weight == null || this.gateDetail.gross_weight == "0") {
      this.gateDetail.gross_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.gross_weight);
      this.gateDetail.gross_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.gross_weight_lbs);
      this.gateDetail.gross_weightFmt = this.gateDetail.gross_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.tractor_weight == null || this.gateDetail.tractor_weight == "0") {
      this.gateDetail.tractor_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.tractor_weight);
      this.gateDetail.tractor_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.tractor_weight_lbs);
      this.gateDetail.tractor_weightFmt = this.gateDetail.tractor_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.chassis_weight == null || this.gateDetail.chassis_weight == "0") {
      this.gateDetail.chassis_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.chassis_weight);
      this.gateDetail.chassis_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.chassis_weight_lbs);
      this.gateDetail.chassis_weightFmt = this.gateDetail.chassis_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.scale_weight == null || this.gateDetail.scale_weight == "0") {
      this.gateDetail.scale_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.scale_weight);
      this.gateDetail.scale_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.scale_weight_lbs);
      this.gateDetail.scale_weightFmt = this.gateDetail.scale_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.tare_weight == null || this.gateDetail.tare_weight == "0") {
      this.gateDetail.tare_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.tare_weight);
      this.gateDetail.tare_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.tare_weight_lbs);
      this.gateDetail.tare_weightFmt = this.gateDetail.tare_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.net_weight == null || this.gateDetail.net_weight == "0") {
      this.gateDetail.net_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.net_weight);
      this.gateDetail.net_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.net_weight_lbs);
      this.gateDetail.net_weightFmt = this.gateDetail.net_weightFmt + this.weight + " lbs";
    }


    if (this.gateDetail.cargo_weight == null || this.gateDetail.cargo_weight == "0") {
      this.gateDetail.cargo_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.gateDetail.cargo_weight);
      this.gateDetail.cargo_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.gateDetail.cargo_weight_lbs);
      this.gateDetail.cargo_weightFmt = this.gateDetail.cargo_weightFmt + this.weight + " lbs";
    }

    if (this.gateDetail.lane_in_by == null) {
      this.gateDetail.lane_in_by = " ";
    }
    if (this.gateDetail.lane_out_by == null) {
      this.gateDetail.lane_out_by = " ";
    }
    if (this.gateDetail.guard_out_by == null) {
      this.gateDetail.guard_out_by = " ";
    }
    if (this.gateDetail.weight_check_by == null) {
      this.gateDetail.weight_check_by = " ";
    }
    if (this.gateDetail.damage_inspection_by == null) {
      this.gateDetail.damage_inspection_by = " ";
    }
    if (this.gateDetail.seal_verification_by == null) {
      this.gateDetail.seal_verification_by = " ";
    }
    if (this.gateDetail.empty_verification_by == null) {
      this.gateDetail.empty_verification_by = " ";
    }
    if (this.gateDetail.roadability_by == null) {
      this.gateDetail.roadability_by = " ";
    }
    if (this.gateDetail.escort_request_by == null) {
      this.gateDetail.escort_request_by = " ";
    }

    if (this.gateDetail.escort_reason == null) {
      this.gateDetail.escort_reason = " ";
    }

    if (this.gateDetail.escort_to_location == null) {
      this.gateDetail.escort_to_location = " ";
    }

    if (this.gateDetail.tcir_by == null) {
      this.gateDetail.tcir_by = " ";
    }
    if (this.gateDetail.prob_elapsed_time == null) {
      this.gateDetail.prob_elapsed_time = " ";
    }
    if (this.gateDetail.stage_id == null) {
      this.gateDetail.stage_id = " ";
    }
    if (this.gateDetail.rpm_inspection_by == null) {
      this.gateDetail.rpm_inspection_by = " ";
    }

    if (this.gateDetail.total_elapsed_time == null) {
      this.gateDetail.total_elapsed_time = " ";
    }
    if (this.gateDetail.cancel_reason_description == null) {
      this.gateDetail.cancel_reason_description = " ";
    }

    if (this.gateDetail.manual_damage_inspection_by == null) {
      this.gateDetail.manual_damage_inspection_by = " ";
    }

    if (this.gateDetail.chassis_verification_by == null) {
      this.gateDetail.chassis_verification_by = " ";
    }

    if (this.gateDetail.slot_booth_by == null) {
      this.gateDetail.slot_booth_by = " ";
    }
    if (this.gateDetail.rpm_alarm_by == null) {
      this.gateDetail.rpm_alarm_by = " ";
    }
    if (this.gateDetail.red_zone_by == null) {
      this.gateDetail.red_zone_by = " ";
    }
    if (this.gateDetail.lane_in_date == null) {
      this.gateDetail.lane_in_date = " ";
    }

    if (this.gateDetail.lane_out_date == null) {
      this.gateDetail.lane_out_date = " ";
    }
    if (this.gateDetail.guard_out_date == null) {
      this.gateDetail.guard_out_date = " ";
    }
    if (this.gateDetail.weight_check_date == null) {
      this.gateDetail.weight_check_date = " ";
    }

    if (this.gateDetail.damage_inspection_date == null) {
      this.gateDetail.damage_inspection_date = " ";
    }

    if (this.gateDetail.chassis_verification_date == null) {
      this.gateDetail.chassis_verification_date = " ";
    }

    if (this.gateDetail.slot_booth_date == null) {
      this.gateDetail.slot_booth_date = " ";
    }

    if (this.gateDetail.rpm_alarm_date == null) {
      this.gateDetail.rpm_alarm_date = " ";
    }
    if (this.gateDetail.red_zone_date == null) {
      this.gateDetail.red_zone_date = " ";
    }
    if (this.gateDetail.seal_verification_date == null) {
      this.gateDetail.seal_verification_date = " ";
    }

    if (this.gateDetail.empty_verification_date == null) {
      this.gateDetail.empty_verification_date = " ";
    }
    if (this.gateDetail.roadability_date == null) {
      this.gateDetail.roadability_date = " ";
    }

    if (this.gateDetail.entered_yard == null) {
      this.gateDetail.entered_yard = " ";
    }
    if (this.gateDetail.exited_yard == null) {
      this.gateDetail.exited_yard = " ";
    }

    if (this.gateDetail.cancel_date == null) {
      this.gateDetail.cancel_date = " ";
    }

    if (this.gateDetail.escort_request_date == null) {
      this.gateDetail.escort_request_date = " ";
    }

    if (this.gateDetail.tcir_date == null) {
      this.gateDetail.tcir_date = " ";
    }
    if (this.gateDetail.rpm_inspection_date == null) {
      this.gateDetail.rpm_inspection_date = " ";
    }
    if (this.gateDetail.manual_damage_inspection_date == null) {
      this.gateDetail.manual_damage_inspection_date = " ";
    }
    if (this.gateDetail.seal_1 == null) {
      this.gateDetail.seal_1 = " ";
    }
    if (this.gateDetail.seal_2 == null) {
      this.gateDetail.seal_2 = " ";
    }
    if (this.gateDetail.seal_3 == null) {
      this.gateDetail.seal_3 = " ";
    }
    if (this.gateDetail.seal_4 == null) {
      this.gateDetail.seal_4 = " ";
    }


    if (this.gateDetail.gateDamages!= null){
      if (this.gateDetail.gateDamages.length>0){
        this.gdData = new MatTableDataSource<GateDamages>(this.gateDetail.gateDamages);
      }else{
        this.gateDetail.gateDamages = [];
        this.gdData = new MatTableDataSource<GateDamages>(this.gateDetail.gateDamages);
      }
    }else{
      this.gateDetail.gateDamages = [];
      this.gdData = new MatTableDataSource<GateDamages>(this.gateDetail.gateDamages);
    }

    if (this.gateDetail.gateErrors!= null){
      if (this.gateDetail.gateErrors.length>0){
        this.geData = new MatTableDataSource<GateError>(this.gateDetail.gateErrors);
      }else{
        this.gateDetail.gateErrors = [];
        this.geData = new MatTableDataSource<GateError>(this.gateDetail.gateErrors);
      }
    }else{
      this.gateDetail.gateErrors = [];
      this.geData = new MatTableDataSource<GateError>(this.gateDetail.gateErrors);
    }



  }

  getListData(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listData.push(this.listDataObj);

    this.clientRequest.requestData = this.listData;
    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.fillUpSavedLists();

      });

  }

  fillUpSavedLists(){
    this.savedLists2 = [];
    if (this.savedList=="Visit"){
      this.listDataObj.type = "V";
    }else if (this.savedList=="Booking"){
      this.listDataObj.type = "B";
    }else if (this.savedList=="Container"){
      this.listDataObj.type = "E";
    }else if (this.savedList=="Chassis"){
      this.listDataObj.type = "H";
    }

    for (var item of this.listData){
      if (item.type == this.listDataObj.type){
        this.savedLists2.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists2.length>0){
      this.savedList2 = this.savedLists2[0].id;
    }
  }


  deleteHit(){
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists2[this.savedLists2.findIndex(xx=>xx.id==this.savedList2)].description,"gateActivity");
    return;
  }

  updateContainerList(fromWhere: string){
    this.submitted = true;
    this.insertNoConts = false;
    this.noListName = false;
    this.insertListExists = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.savedList=="Visit"){
        this.listDataObj.type = "V";
      }else if (this.savedList=="Booking"){
        this.listDataObj.type = "B";
      }else if (this.savedList=="Container"){
        this.listDataObj.type = "E";
      }else if (this.savedList=="Chassis"){
        this.listDataObj.type = "H";
      }

      if (this.txtFromArea==undefined || this.txtFromArea==""){
        if (fromWhere=="I" ||fromWhere=="U"){
          this.insertNoConts = true;
        }
        return;
      }
      if (fromWhere=="I" && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }

      if ((fromWhere=="U" ) && (this.savedList2==null || this.savedList2=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type ==this.listDataObj.type) !=-1){
        this.insertListExists = true;
        return;
      }
      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere!="D"){
        if (fromWhere=="I"){
          this.listDataObj.name = this.myNewListName;
          if (this.savedList=="Visit"){
            this.listDataObj.type = "V";
          }else if (this.savedList=="Booking"){
            this.listDataObj.type = "B";
          }else if (this.savedList=="Container"){
            this.listDataObj.type = "E";
          }else if (this.savedList=="Chassis"){
            this.listDataObj.type = "H";
          }
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList2;
        this.fillUpSavedLists();
        if (this.savedLists2.length > 0) {
          if (fromWhere == "I") {
            this.savedList2 = this.savedLists2[this.savedLists2.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList2 = this.savedLists2[0].id;
          }else{
            this.savedList2 = this.savedLists2[this.savedLists2.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","gateActivity");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","gateActivity");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","gateActivity");

        }

        this.submitted= false;



      });

  }



  checkChassisFormat(arrayValue: string): boolean{

    var pattern = new RegExp('^[a-zA-Z]{4}([0-9]{1,7})$');
    var result=pattern.test(arrayValue);
    if (result){
      return true;
    }else{
      return false;
    }
  }

  showContainersFromList(){
    var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
    if (indx!=-1){
      this.txtFromArea = "";
      for (var ii=0;ii<this.listData[indx].data.length; ii++){
        this.txtFromArea =  this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }
}


